export default __webpack_public_path__ + "static/media/cbinvestors_site_logo.dd88900f.png";